<template>
    <div>
        <DataTable :value="laboratories" lazy paginator
                   v-model:rows="searchCriteria.page.limit" v-model:first="searchCriteria.page.offset"
                   removableSort :totalRecords="totalRecords" :loading="loading" @page="onPage"
                   @sort="onPage" :rowsPerPageOptions="[5,10,20,50]" selection-mode="single"
                   v-model:selection="selectedTableElement" @row-click="onRowSelect"
                   filterDisplay="row" class="laboratory-table" scrollable
                   scrollHeight="calc(100vh - 300px)">
            <Column field="id" header="ID" :sortable="true" filterField="id"
                    :showFilterMenu="false" :showClearButton="false" class="w-2">
                <template #filter>
                    <CustomInputNumber name="id" v-model="searchCriteria.id"
                                       placeholder="type..." class="mb-0"
                                       @update:modelValue="search" />
                </template>
            </Column>
            <Column field="name" header="Name" :sortable="true" filterField="name"
                    :showFilterMenu="false" :showClearButton="false" class="w-2">
                <template #filter>
                    <CustomInputText name="name" v-model="searchCriteria.name"
                                     placeholder="type..." class="mb-0"
                                     @update:modelValue="search" />
                </template>
            </Column>
            <template #empty>
                No labolatories found.
            </template>
        </DataTable>
    </div>
</template>

<script>
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import {
    searchLaboratory,
    searchLaboratoryCount,
} from "@/swagger/vue-api-client";
import CustomInputText from "@/components/form/CustomInputText.vue";
import CustomInputNumber from "@/components/form/CustomInputNumber.vue";
import { ScrollToUtils } from "@/utils/ScrollToUtils";

export default {
    name: "LaboratoryTable",
    components: {
        Column,
        DataTable,
        CustomInputNumber,
        CustomInputText,
    },

    props: {
        modelValue: null,
    },

    emits: ["update:modelValue", "showForm"],

    data() {
        return {
            loading: false,
            totalRecords: 0,
            laboratories: [],
            searchCriteria: this.getClearSearchCriteria(),
            selectedTableElement: null,
        };
    },

    mounted() {
        this.updateTotalRecords();
        this.onPage(this.getFirstPage());
    },

    methods: {
        search() {
            this.onPage(this.getFirstPage());
            this.updateTotalRecords();
        },

        onPage(event) {
            this.loading = true;

            this.searchCriteria.page.offset = event.first;
            this.searchCriteria.page.limit = event.rows;
            this.searchCriteria.page.sortField = event.sortField;
            this.searchCriteria.page.sortOrder = event.sortOrder;

            searchLaboratory({body: this.searchCriteria}).then((response) => {
                this.laboratories = response.data;
                this.loading = false;
            });
        },

        updateTotalRecords() {
            searchLaboratoryCount({body: this.searchCriteria}).then((response) => {
                this.totalRecords = response.data;
            });
        },

        getFirstPage() {
            return {
                first: this.searchCriteria.page.offset,
                rows: this.searchCriteria.page.limit,
            };
        },

        onRowSelect(event) {
            ScrollToUtils.scrollToElement();
            this.$emit("showForm");
            this.selectedLaboratory = event.data
        },

        getClearSearchCriteria() {
            return {
                id: null,
                name: "",
                page: {
                    limit: 10,
                    offset: 0,
                    sortField: null,
                    sortOrder: null,
                },
            };
        },

        addNewLaboratory() {
            this.selectedTableElement = null;
        },

        reloadTable() {
            this.search();
        },
    },

    computed: {
        selectedLaboratory: {
            get() { return this.modelValue; },
            set(value) { this.$emit("update:modelValue", value); },
        },
    },
};
</script>

<style lang="scss">

</style>
